import { render, staticRenderFns } from "./ValidationGroup.vue?vue&type=template&id=b5489ad6&"
import script from "./ValidationGroup.vue?vue&type=script&lang=ts&"
export * from "./ValidationGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports